import {Vue} from 'ui.vue';

import "./BXmakerAuthuserphoneEnterAuthByEmailCodeForm.styl";

Vue.component('BXmakerAuthuserphoneEnterAuthByEmailCodeForm', {
    name: 'BXmakerAuthuserphoneEnterAuthByEmailCodeForm',
    data() {
        return {};
    },
    computed: {},
    methods: {
        onInputEmail(value){
            this.$root.setEmail(value);
        },
        onEnterEmail(value){
            this.$root.setEmail(value);
            this.onClickDone();
        },
        onClickDone(){
            this.$root.startConfirmEmailCode();
        },
        onClickAuthByPhone() {
            this.$root.setAuthByPhone();
        },
    },

    //language=Vue
    template: `
      <div class="bxmaker-authuserphone-enter-authbyemailcode-form">

        <BXmakerAuthuserphoneHeader>
          {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTHBYEMAILCODE_FORM_TITLE}}
        </BXmakerAuthuserphoneHeader>

        <div class="bxmaker-authuserphone-enter-authbyemailcode-form__subtitle">
          {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTHBYEMAILCODE_FORM_SUBTITLE}}
        </div>

        <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error"/>

        <BXmakerAuthuserphoneInput 
             :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTHBYEMAILCODE_FORM_INPUT"
             :value="$root.email"
             @onInput="onInputEmail"
             @onEnter="onEnterEmail"
             name="EMAIL"             
             type="email"
        />

        <BXmakerAuthuserphoneCaptcha
            :code="$root.captchaCode"
            :src="$root.captchaSrc"
            :length="$root.captchaLength"
            :loader="$root.captchaLoader"
            @onInput="$root.setCaptchaCode"
            @onComplete="onClickDone"
            @onRefresh="$root.refreshCaptcha"
        />


        <BXmakerAuthuserphoneButton
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTHBYEMAILCODE_FORM_BUTTON"
            :loader="$root.startLoader"
            @onClick="onClickDone"
        />
        
       
          <div class="bxmaker-authuserphone-enter-auth-form__by">
            <BXmakerAuthuserphoneLink @onClick="onClickAuthByPhone">
              {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_FORM_BY_PHONE}}
            </BXmakerAuthuserphoneLink>
          </div>
        

      </div>
    `,
});